import { ASSET_UPLOAD_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(ASSET_UPLOAD_ENDPOINT);
export default instance;
